import { AddOutlined } from "@mui/icons-material";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

import { RoutePath } from "../../models/routePath";
import "./EditableItemList.scss";

interface EditableItemListProps {
  listCount: number;
  onAdd: () => void;
}

const EditableItemList = (
  props: React.PropsWithChildren<EditableItemListProps>,
) => {
  const { t } = useTranslation();
  const { listCount, children, onAdd } = props;

  const hideAddButton = window.location.pathname.includes(
    RoutePath.ConfirmQuantities,
  );

  const renderEmptyListItem = (
    <ListItem divider className="list-item-empty">
      <ListItemText primary={t("noItemsAdded")} />
    </ListItem>
  );

  return (
    <div className="editable-item-list">
      {listCount === 0 ? renderEmptyListItem : <List>{children}</List>}
      {!hideAddButton ? (
        <div className="list-item-add-container">
          <IconButton color="primary" onClick={onAdd}>
            <AddOutlined />
          </IconButton>
        </div>
      ) : undefined}
    </div>
  );
};

export default EditableItemList;
